<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('lost_and_found')">
            <app-default-button
                :title="$fieldTitle('add', 'lost_and_found', true)"
                v-if="$can('create_hotel_lost_found')"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="hotel-lost-found-table"
            :options="options"
            @action="triggerActions"
            @getFilteredValues="getFilterValues"
        />

        <app-hotel-lost-found-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-hotel-lost-found-process
            v-if="isModalProcessActive"
            v-model="isModalProcessActive"
            :selected-url="selectedUrl"
            @close="isModalProcessActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('hotel-lost-found-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import HotelLostFoundMixins from "../../../Mixins/HotelLostFoundMixins";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";

export default {
    name  : "AppHotelLostFound",
    mixins: [HelperMixin, HotelLostFoundMixins, TENANT_BASE_URL],
    data() {
        return {
            isModalProcessActive: false,
            isModalActive       : false,
            selectedUrl         : '',
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${TENANT_BASE_URL}app/hotel/lost-found/${row.id}`;
                this.isModalActive = true;
            } else if (action.title === this.$t('process')) {
                this.selectedUrl          = `${TENANT_BASE_URL}app/hotel/lost-found/${row.id}`;
                this.isModalProcessActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
    }
}
</script>